module.exports = __webpack_public_path__ + "static/media/pic_backuser@2x.41781a7a.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/user/pic_backuser@2x.png
// module id = 359
// module chunks = 0